import React from "react"
import StockTechnicalDetailsUpdate from "./StockTechnicalDetailsUpdate"
import DataCard from "components/Common/DataCard"
import { prepareDataWithLoading } from "helpers/loading_helper"

export default function TechnicalDetails({ stock, loading = false }) {
  const fields = [
    { label: "Engine CC", value: stock?.engine_c_c?.name ? `${stock.engine_c_c.name} CC` : "-" },
    { label: "Chassis Code", value: stock?.chassis_code?.name },
    { label: "Engine Code", value: stock?.engine_code?.name },
    { label: "Fuel Type", value: stock?.fuel_type?.name },
    { label: "Engine Type", value: stock?.engine_type?.name },
    { label: "Key Type", value: stock?.key_type?.name },
    { label: "Auction Grade", value: stock?.auction_grade?.name },
    { label: "Transmission", value: stock?.transmission?.name },
  ]

  const data = prepareDataWithLoading(fields, loading)

  return (
    <DataCard
      title="Technical Details"
      icon="bx bx-chip"
      data={data}
      action={loading ? null : <StockTechnicalDetailsUpdate stock={stock} />}
    />
  )
}
